import React, { Component } from "react";
import { Link } from "react-router-dom";
class ServiceSlide extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      blogs: [
        {
          id: 1,
        },
        {
          id: 1,
        },
        {
          id: 1,
        },
        {
          id: 1,
        },
        {
          id: 1,
        },
        {
          id: 1,
        },
        {
          id: 1,
        },
        {
          id: 1,
        },
        {
          id: 1,
        },
        {
          id: 1,
        },
      ],
    };
  }

  render() {
    return (
      <div className="row-services">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div
                className="themesflat-spacer clearfix"
                data-desktop={81}
                data-mobile={60}
                data-smobile={60}
              />
              <div
                className="themesflat-carousel-box data-effect clearfix"
                data-gap={30}
                data-column={3}
                data-column2={2}
                data-column3={1}
                data-auto="true"
              >
                <div className="owl-carousel owl-theme">
                  {this.state.blogs.map((data) => (
                    <div className="themesflat-image-box style-2 clearfix">
                      <div className="image-box-item">
                        <div className="inner">
                          <div className="thumb data-effect-item">
                            <img
                              src="assets/img/imagebox/image-box-1-370x215.jpg"
                              alt="altimage"
                            />
                            <div className="overlay-effect bg-color-accent" />
                          </div>
                          <div className="text-wrap">
                            <h5 className="heading">
                              <Link to="#">DESIGN-BUILD</Link>
                            </h5>
                            <p className="letter-spacing-01">
                              Waaaae develop and understand project expectations
                              and then manage those needs with a design [...]
                            </p>
                            <div className="elm-readmore">
                              <Link to="page-services-detail.html">
                                DETAILS
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div
                className="themesflat-spacer clearfix"
                data-desktop={15}
                data-mobile={15}
                data-smobile={15}
              />
              <div
                className="themesflat-carousel-box data-effect clearfix"
                data-gap={30}
                data-column={3}
                data-column2={2}
                data-column3={1}
                data-auto="true"
              >
                <div className="owl-carousel owl-theme">
                  {this.state.blogs.map((data) => (
                    <div className="themesflat-image-box style-2 clearfix">
                      <div className="image-box-item">
                        <div className="inner">
                          <div className="thumb data-effect-item">
                            <img
                              src="assets/img/imagebox/image-box-1-370x215.jpg"
                              alt="altimage"
                            />
                            <div className="overlay-effect bg-color-accent" />
                          </div>
                          <div className="text-wrap">
                            <h5 className="heading">
                              <Link to="#">DESIGN-BUILD</Link>
                            </h5>
                            <p className="letter-spacing-01">
                              We develop and understand project expectations and
                              then manage those needs with a design [...]
                            </p>
                            <div className="elm-readmore">
                              <Link to="page-services-detail.html">
                                DETAILS
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
              <div
                className="themesflat-spacer clearfix"
                data-desktop={45}
                data-mobile={60}
                data-smobile={60}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ServiceSlide;
